import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetCardDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { Selector, Option } from '../Selects/Selector';
import {
  CardType,
  CardTypeText,
} from '../../../common/spdCore/validation/schemas';

export interface CardSelectorProps {
  readOnly?: boolean;
  examId?: string;
  cardType?: CardType;
  cards?: GetCardDto[];
  value?: string;
  className?: string;
  onChange?: (option: Option) => void;
  clearable?: boolean;
}

export default (props: CardSelectorProps) => {
  const spd = useSpdCore();
  const [cards, setCards] = useState<GetCardDto[]>([]);
  const [displayName, setDisplayName] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (props.value) {
      spd.cards
        .get(props.value)
        .then(cr => {
          setDisplayName(
            `${cr.number || '---'} (${CardTypeText[cr.type as unknown as CardType]})`,
          );
        })
        .catch(error =>
          console.log(`Wystąpił problem z pobraniem baterii testów. ${error}`),
        );
    }
  }, [props.value, spd.cards]);

  useEffect(() => {
    if (props.cards !== undefined) {
      setCards(
        props.cardType
          ? props.cards.filter(c => c.type === props.cardType)
          : props.cards,
      );
      setReady(true);
      return;
    }

    let mounted = true;
    if (props.examId) {
      spd.cards
        .getAllByExam(props.examId)
        .then(crs => {
          if (mounted) {
            setCards(
              props.cardType ? crs.filter(c => c.type === props.cardType) : crs,
            );
            setReady(true);
          }
        })
        .catch(error =>
          console.log(`Wystąpił problem z pobraniem kart do badania. ${error}`),
        );
    } else {
      setCards([]);
      setReady(true);
    }

    return () => {
      mounted = false;
    };
  }, [spd.cards, props.examId, props.cardType, props.cards]);

  const provider = async (text: string) => {
    const values = cards.filter(v => {
      const name = `${v.number || '---'} (${CardTypeText[v.type as unknown as CardType]})`;
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return values.map(v => {
      return {
        label: `${v.number || '---'} (${CardTypeText[v.type as unknown as CardType]})`,
        value: v.id,
      };
    });
  };

  return ready ? (
    <Selector
      uniqueKey={'cards-' + JSON.stringify(cards)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={'Wskaż...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
      clearable={props.clearable}
    />
  ) : (
    <Skeleton />
  );
};
